import React, { Component, Suspense } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import "./../../Pages/Register/Register.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Icon from "react-icons-kit";
import { eye } from "react-icons-kit/fa/eye";
import { eyeSlash } from "react-icons-kit/fa/eyeSlash";
import JejakinLogo from "./../../../images/jejakin-marketplace.svg";
// import JejakinLogoIcon from "./../../../images/jejakin-marketplace-icon.svg";
import "./Login.scss";
import i18n from 'i18next';
import { Translation } from "react-i18next";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderButton: false,
      email: null,
      password: null,
      showpassword: false,
    };
  }
  showPassword = () => {
    this.setState({ showpassword: !this.state.showpassword });
  };
  login = (e) => {
    e.preventDefault();
    this.setState({ loaderButton: true });
    let data = {
      email: this.state.email,
      password: this.state.password,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API_HOST + "/login/user",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    }).then(
      (response) => {
        console.log("response data ", response.data);
        if (response.data.success) {
          toast.success(i18n.t('success'))
          const hexa = [
            "f368e0",
            "ff9f43",
            "ff6b6b",
            "1dd1a1",
            "00d2d3",
            "54a0ff",
          ];
          const randomHexa = hexa[Math.floor(Math.random() * hexa.length)];
          localStorage.setItem("userData", JSON.stringify(response.data));
          localStorage.setItem("hexaColor", randomHexa);
          if (response.data.data.userType === 0) {
            if (response.data.data.fullName.includes(" ")) {
              localStorage.setItem(
                "initialName",
                response.data.data.fullName.match(/\b(\w)/g).join("")
              );
            } else {
              localStorage.setItem(
                "initialName",
                response.data.data.fullName.match(/\b(\w)/g).join("")
              );
            }
          } else {
            if (response.data.data.companyName.includes(" ")) {
              localStorage.setItem(
                "initialName",
                response.data.data.companyName.match(/\b(\w)/g).join("")
              );
            } else {
              localStorage.setItem(
                "initialName",
                response.data.data.companyName.match(/\b(\w)/g).join("")
              );
            }
          }
          // this.props.history.push("/profile");
          setTimeout(() => {
            this.setState({ loaderButton: false });
          }, 1000);
        } else {
          if (response.data.error.length) {
            for (var er = 0; er < response.data.error.length; er++) {
              var obj = response.data.error[er];
              for (var key in obj) {
                console.log(key, obj[key]);
                toast.error(i18n.t(obj[key]));
              }
              this.setState({ loaderButton: false });
            }
          } else {
            this.setState({ loaderButton: false });
            toast.error(response.data.error);
          }
        }
      },
      (error) => {
        toast.error("Error! " + error);
        setTimeout(() => {
          this.setState({ loaderButton: false });
        }, 1000);
      }
    );
  };
  render() {
    if (localStorage.getItem("userData")) {
      return <Redirect to={"/?ref=login"} />;
    }

    return (
      <React.Fragment>
        <div className="mpl-page">
          <ToastContainer />
          <Suspense fallback={"...Loading"}>
            <Translation>
              {(t) => (
                <div className="wrap-account">
                  <div className="wp-ac wrap-left">
                    <div className="logo-fixed">
                      <Link to="/">
                        <img src={JejakinLogo} alt="Jejakin" />
                      </Link>
                    </div>
                    <div className="wp-login">
                      {/* <h2>{t("login_register.masuk")}</h2> */}
                      <div className="row">
                        <div className="col-auto">
                          <h3 className="ts-underline no-bg mb-5">
                            <Link to="/register">{t("login_register.daftar")}</Link>
                          </h3>
                        </div>
                        <div className="col-auto">
                          <h3 className="ts-underline mb-5">
                            {t("login_register.masuk")}
                          </h3>
                        </div>
                      </div>
                      <form id="formLogin" onSubmit={this.login}>
                        <div className="form-group">
                          <label htmlFor="email" className="label-group">
                            Email
                          </label>
                          <input
                            id="email"
                            type="text"
                            className="field-group"
                            name="email"
                            onChange={(e) =>
                              this.setState({ email: e.target.value })
                            }
                            value={this.state.email || ""}
                          />
                        </div>
                        <div className="form-group nom">
                          <label htmlFor="password" className="label-group">
                            {t("login_register.password")}
                          </label>
                          {this.state.showpassword ? (
                            <div className="field-group-input">
                              <input
                                id="password"
                                type="text"
                                className="field-group"
                                name="password"
                                onChange={(e) =>
                                  this.setState({ password: e.target.value })
                                }
                                value={this.state.password || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eye}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="field-group-input">
                              <input
                                id="password"
                                type="password"
                                className="field-group"
                                name="password"
                                onChange={(e) =>
                                  this.setState({ password: e.target.value })
                                }
                                value={this.state.password || ""}
                              />
                              <div className="icon-group">
                                <Icon
                                  size={24}
                                  icon={eyeSlash}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    this.showPassword();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          <div className="mt-2 float-right">
                            <Link
                              to="/forgot"
                              className="tx-green text-no-underline text-small"
                            >
                              {t("login_register.lupa")}
                            </Link>
                          </div>
                          <div className="clearboth">&nbsp;</div>
                        </div>
                        <div className="form-group mb-0">
                          <button className="btn btn-green ">
                            {this.state.loaderButton === true ? (
                              <div className="loader"></div>
                            ) : (
                              t("login_register.masuk")
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="wp-ac wrap-right">
                    <div className="green-ov">&nbsp;</div>
                    <div className="content-highlight">
                      <h2>{t("login_register.quote")}</h2>
                    </div>
                    <div className="foot">
                      <span className="copyright">
                        © 2020 Jejak.in, All rights reserved
                      </span>
                      <span className="float-right social-link">
                        <a href="https://bit.ly/2BiY5n0" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-linkedin-in"></i>
                        </a>{" "}
                        <a href="https://bit.ly/2Bk6d6M" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-youtube"></i>
                        </a>{" "}
                        <a href="https://bit.ly/32yy8eb" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </Translation>
          </Suspense>
        </div>
      </React.Fragment>
    );
  }
}

export default Login;
